// extracted by mini-css-extract-plugin
export var required = "_hr-0";